// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
};

const ConfirmCrossBorderModal = (props: Props) => {
  const {
    visible,
    close,
    submit,
  } = props;

  const DeleteVendor = () => {
    submit();
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={DeleteVendor} type="danger">Proceed</SpButton>,
      ]}
      title="Confirm Transaction Details"
    >
      <div className="px-4">
        <div className="mt-1">By selecting an India bank account, additional charges will apply.
          Do you wish to proceed with this transaction?
        </div>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default ConfirmCrossBorderModal;
